import {
  type CSSProperties,
  type ExtractPropTypes,
  Transition,
  defineComponent,
} from 'vue'
import {
  HAPTICS_FEEDBACK,
  createNamespace,
  makeObjectProp,
  makeStringProp,
  truthProp,
} from '@xzx-design/utils'
import { Icon } from '@xzx-design/components/icon'
import { CloseSmall } from '@xzx-design/icons-vue'
import type { IconsComponent } from '@xzx-design/components/icon'

import type { TagTheme, TagType } from './types'

const [name, bem] = createNamespace('tag')

export const tagProps = {
  // size: String as PropType<TagSize>,
  mark: Boolean,
  show: truthProp,
  icon: makeObjectProp<IconsComponent>(null),
  type: makeStringProp<TagType>('default'),
  theme: makeStringProp<TagTheme>('default'),
  color: String,
  round: Boolean,
  textColor: String,
  closeable: Boolean,
}

export type TagProps = ExtractPropTypes<typeof tagProps>

export default defineComponent({
  name,

  props: tagProps,

  emits: ['close'],

  setup(props, { slots, emit }) {
    const onClose = (event: MouseEvent) => {
      event.stopPropagation()
      emit('close', event)
    }

    const getStyle = (): CSSProperties => {
      if (props.theme === 'plain') {
        return {
          color: props.textColor || props.color,
          borderColor: props.color,
        }
      }
      return {
        color: props.textColor,
        background: props.color,
      }
    }

    const renderTag = () => {
      const { type, mark, round, icon, closeable, theme } = props

      const classes: Record<string, unknown> = {
        mark,
        round,
        [theme]: true,
      }
      // if (size) {
      //   classes[size] = size
      // }

      const CloseIcon = closeable && (
        <Icon class={[bem('close'), HAPTICS_FEEDBACK]} onClick={onClose}>
          <CloseSmall />
        </Icon>
      )

      const prefixIcon = icon && (
        <Icon class={[bem('icon')]}>
          <icon />
        </Icon>
      )

      return (
        <span style={getStyle()} class={bem([classes, type])}>
          {prefixIcon}
          {slots.default?.()}
          {CloseIcon}
        </span>
      )
    }

    return () => (
      <Transition name={props.closeable ? 'xzx-fade' : undefined}>
        {props.show ? renderTag() : null}
      </Transition>
    )
  },
})
